var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [_c("Header"), _vm._v(" "), _vm._m(0), _vm._v(" "), _c("Footer")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "main" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("h1", [_vm._v("CLICK2GIV SOLUÇÕES ONLINE LTDA.")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h2", [_vm._v("Click2giv LTDA.")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h3", [_vm._v("Política de Privacidade")]),
            _vm._v(" "),
            _c("h4", [_vm._v("17 de maio de 2016")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                'Esta Política de Privacidade explica como são coletadas, utilizadas e divulgadas pela click2giv Serviços on Line Ltda. ("click2giv"), as informações sobre os Usuários. A Política de Privacidade aplica-se às informações que coletamos dos Usuários ao utilizarem-se de nossos Serviços ou da plataforma click2giv.'
              )
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Coleta de Informações Pessoais")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "A click2giv coleta algumas informações pessoais do Usuário automaticamente na efetivação do cadastro no website tais como: seu nome, endereço de email, endereço residencial ou comercial e número de telefone. A click2giv coleta também algumas informações demográficas, tais como, idade, sexo, preferências e interesses. Há também a coleta de informações sobre as ferramentas e softwares utilizados que podem incluir: seu endereço de IP, tipo de navegador, nomes de domínio, tempos de acesso e consultas a páginas do website. Estas informações serão usadas pela click2giv para manter a qualidade do serviço e fornecer estatísticas gerais a respeito do uso da ferramenta web."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "A click2giv incentiva o Usuário a ler a Política de Privacidade de modo que o mesmo possa compreender como o website coleta, usa e compartilha suas informações. A click2giv não é responsável pela Política de Privacidade ou qualquer outro conteúdo exibido fora do seu website."
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h3", [_vm._v("Uso de Informações Pessoais")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "A click2giv coleta e usa suas informações pessoais para operar o seu website e realizar os Serviços solicitados pelos próprios usuários. A click2giv usa também suas informações de identificação pessoal para informá-lo sobre outros produtos ou serviços disponíveis no website click2giv. A click2giv pode também contatá-lo através de enquetes para conduzir pesquisas sobre sua opinião acerca de serviços atuais ou de serviços novos ou potenciais. A click2giv não vende nem aluga suas listas de clientes a terceiros. Todos os terceiros são proibidos de usar a sua informação pessoal a não ser para fornecer serviços a click2giv, e são obrigados a manter a confidencialidade de suas informações."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "A click2giv se mantém informada sobre os acessos e visitas ao seu site a fim de determinar quais serviços são os mais populares. Estes dados poderão ser usados para satisfazer de maneira customizada, clientes cujo comportamento indique interesse por áreas específicas."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "O website da click2giv irá disponibilizar suas informações pessoais sem aviso prévio somente se forem requisitadas por lei ou se forem necessárias para: (a) estar em conformidade com mandados legais ou para obedecer a processos judiciais ou administrativos que deverão ser cumpridos pela empresa; (b) proteger e defender os direitos de propriedade da click2giv; e, (c) agir sob circunstancias que exijam proteção da segurança dos usuários da click2giv ou do público em geral."
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h3", [_vm._v("Uso de Cookies")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "O site click2giv usa cookies para personalizar sua experiência online. Um cookie é um arquivo texto armazenado no seu computador por um servidor de páginas web. Os cookies não podem ser usados para executar programas ou enviar vírus para o seu computador. Os cookies são atribuídos exclusivamente a você, e só podem ser lidos pelo servidor que os enviou."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Um dos propósitos principais dos cookies é economizar o seu tempo. O cookie informa ao servidor web que você retornou a uma página específica. Por exemplo, durante o login, você pode optar por guardar suas informações, dessa maneira toda vez que visitar nosso site, não será necessário preencher o seu email e senha."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Você pode aceitar ou recusar os cookies. A maioria dos navegadores aceitam os cookies automaticamente, mas você pode modificar as configurações do seu navegador para rejeitá-los. Se você se decidir por não aceitar os cookies, você não terá a total experiência das características interativas dos serviços e dos websites click2giv que visitou."
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h3", [_vm._v("Segurança das suas Informações Pessoais")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "A click2giv assegura que as suas informações pessoais não serão acessadas, usadas ou reveladas de forma não autorizada. A click2giv assegura que tais informações estão em um ambiente controlado, seguro e protegido de acessos não autorizados. Quando suas informações pessoais (como o número de cartão de crédito) são transmitidas para outros sites, as informações estão protegidas através do uso de encriptação, como o protocolo SSL - Secure Socket Layer."
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h3", [_vm._v("Alteração da Política de Privacidade")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "A click2giv poderá, ocasionalmente, atualizar esta Política de Privacidade. A click2giv encoraja você a rever este documento periodicamente para estar informado sobre como a empresa está protegendo sua informação."
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h3", [_vm._v("Atualizações da política de privacidade.")]),
            _vm._v(" "),
            _c("p", [_vm._v("17 maio de 2016 ")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-210d5cf0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-210d5cf0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Privacy.vue
// module id = null
// module chunks = 